import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, Button, IconButton, Tooltip, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function BannerManagement() {
    const [dataSource, setDataSource] = useState([]);
    const [preview, setPreview] = useState(null);
    const [type, setType] = useState("Banner");
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [editState, setEditState] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [openDelete, setOpenDelete] = React.useState(false);
    const [selectedBanner, setSelectedBanner] = React.useState(null);
    const [previewOpen, setPreviewOpen] = React.useState(false);
    const [previewImage, setPreviewImage] = React.useState("");
    useEffect(() => {
        fetchMainCategory();
    }, []);
    const fetchMainCategory = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "banner";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
            const formData = new FormData();
            formData.append('file', file);
            try {
                setLoading(true);
                const response = await fetch(webEndPoint + 'upload', {
                    method: 'POST',
                    body: formData,
                });
                const data = await response.text();
                setImage(data);
                setLoading(false);
            } catch (error) {
                setMessage('Error during file upload:');
                setSnackbar(true);
                setLoading(false);
            }
        }
    };
    const handleAdd = () => {
        setEditState(null);
        setOpenModal(true);
    };
    const handleEdit = (banner) => {
        setEditState(banner);
        setPreview(banner.image_url);
        setType(banner.image_type);
        setOpenModal(true);
    };
    const handleSave = async () => {
        if (!preview) {
            setMessage("Banner Image are Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const categoryEditData = {
                    image_type: type,
                    image_url: image ? image : preview
                };
                try {
                    let url = webEndPoint + "banner/" + editState.rfId;
                    const response = await makeRequest("put", url, categoryEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Banner Image Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const categoryAddData = {
                    image_type: type,
                    image_url: image
                };
                try {
                    let url = webEndPoint + "banner";
                    const response = await makeRequest("post", url, categoryAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Banner Image Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            setDataSource([]);
            fetchMainCategory();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleClose = () => {
        setOpenModal(false);
    };
    const handleConfirmDelete = async () => {
        if (selectedBanner) {
            try {
                let url = webEndPoint + "banner/" + selectedBanner?.rfId;
                const response = await makeRequest("delete", url);
                if (response) {
                    setLoading(false);
                    setMessage("Banner Image Removed Successfully");
                }
            } catch (err) {
                console.error(err);
            } finally {
                setOpenDelete(false);
                setSelectedBanner(null);
                setLoading(false);
            }
        }
    };
    const columns = ["S.No", "Banner", "Type", "Action"];
    const rows = dataSource.map((banner, i) => [i + 1, <img src={banner?.image_url} alt="banner" style={{ width: 150, height: 60, objectFit: "cover", borderRadius: 5, cursor: "pointer" }} onClick={() => { setPreviewImage(banner?.image_url); setPreviewOpen(true); }} />,
    banner.image_type,
    <Box>
        <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => handleEdit(banner)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
            <IconButton color="error" onClick={() => { setSelectedBanner(banner); setOpenDelete(true); }}>
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Banner</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={handleAdd}>Add Banner</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Main Category" : "Add Main Category"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>Upload Image </Typography>
                        <Button variant="contained" component="label"> Choose File
                            <input type="file" accept="image/*" hidden onChange={handleImageChange} />
                        </Button>
                        {preview && (
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="caption">Preview:</Typography>
                                <Box component="img" src={preview} alt="preview" sx={{ width: "100%", height: 150, objectFit: "cover", mt: 1, borderRadius: 1 }} />
                            </Box>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
                <DialogTitle>Delete Banner</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this banner?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDelete(false)}>Cancel</Button>
                    <Button color="error" onClick={handleConfirmDelete}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="md">
                <DialogContent sx={{ position: "relative", p: 1 }}>
                    <IconButton onClick={() => setPreviewOpen(false)} sx={{ position: "absolute", top: 8, right: 8, background: "#fff" }}>
                        <CloseIcon />
                    </IconButton>
                    <img src={previewImage} alt="preview" style={{
                        width: "100%", maxHeight: "80vh", objectFit: "contain", borderRadius: 8
                    }} />
                </DialogContent>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}